import { useQuery } from '@tanstack/react-query';

import { WorkingHours } from 'src/features/workingHours/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/site/:siteId/site-working-hours/:hoursId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    siteId: string;
    hoursId: string;
    parkingId: string;
}
const queryFn = ({ siteId, hoursId, parkingId }: DTO): Promise<WorkingHours> => {
    return axios.get(formatResourcePath(RESOURCE, { siteId, hoursId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetWorkingHours };
